import { useCallback, useEffect, useMemo } from "react"
import { useSearchParams } from "react-router-dom"

import { getTemplateLibrary } from "store/api/contractorsApi"
import { useAppSelector } from "store/hooks"
import { UITypes } from "types"

import { MessageForm } from "components/form/MessageForm"

import { useMessageTemplateContext } from "../MessageTemplateContainer/MessageTemplateContext"

export const MessageTemplateAdd = () => {
  const [searchParams] = useSearchParams()
  const templateId = searchParams.get("id")
  const selecttTemplateLibrary = useMemo(() => getTemplateLibrary.select(), [])
  const templateLibrary = useAppSelector(selecttTemplateLibrary)
  const { onCreateTemplate, isLoading, currentTemplateLibrary, setCurrentTemplateLibrary } = useMessageTemplateContext()

  const trasformEditData = (): UITypes.MessageTemplate | undefined => {
    if (!currentTemplateLibrary) return undefined

    return {
      title: currentTemplateLibrary?.title,
      message: currentTemplateLibrary?.description,
      message_rich: currentTemplateLibrary?.description_rich,
    }
  }

  const onSetCurrentTemplate = useCallback(() => {
    const templatesList = templateLibrary?.data?.data
    if (!templateId || !templatesList?.length) {
      setCurrentTemplateLibrary(null)
    } else {
      const currentTemplate = templatesList
        ?.flatMap(library => library?.items)
        ?.filter(item => item.id === Number(templateId))[0]
      setCurrentTemplateLibrary(currentTemplate)
    }
  }, [templateLibrary, templateId, setCurrentTemplateLibrary])

  useEffect(() => {
    onSetCurrentTemplate()
  }, [onSetCurrentTemplate])

  return <MessageForm isLoading={isLoading} onSave={onCreateTemplate} editableTemplate={trasformEditData()} />
}
